export default "__VITE_ASSET__BxVsfOGT__"